import axios from "axios";
import { BUILDING_METADATA_SERVICE_BASE } from "../constants";
import { getHeaders } from './AuthService';

export const getProducts = async () => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/products/`, 
      { headers: await getHeaders() }
    );

    return results.data;
  };

  export const addProductToAirtable =  async (product) => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('appqttzwZNgh14JHG');

    let records = []

    records.push({
        "fields": {
            company_name: product.company,
            model_name: product.model,
        }
    })
    let record = await base('product').create(
        {
            company_name: product.company,
            model_name: product.model
        }
    );
    return record.fields["product_id"]
}
